import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import $ from 'jquery';
import DailyAksharUsageReport from './DailyAksharUsageReport';
import MonthlyAksharUsageReport from './MonthlyAksharUsageReport';
import WeeklyAksharUsageReport from './WeeklyAksharUsageReport';

class AksharReportTab extends Component {
    componentDidMount() {
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/platform/cloud-akshar/reports";
            var path1 = window.origin + "/platform/cloud-akshar/reports/";
            if (currentPath === path || currentPath === path1) {
                $("#akshar-daily-report").addClass('active');
            } else if (currentPath.includes("/cloud-akshar/reports/monthly-reports")) {
                $("#akshar-monthly-report").addClass('active');
            } else if (currentPath.includes("/cloud-akshar/reports/weekly-reports")) {
                $("#akshar-weekly-report").addClass('active');
            }
            else {
                $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
            }
            $("#akshar-daily-report,#akshar-monthly-report, #akshar-weekly-report")
                .on("click", function () {
                    $("#akshar-daily-report,#akshar-monthly-report, #akshar-weekly-report")
                        .removeClass('active');
                    localStorage.setItem("last-akshar-report-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (
            <Router basename={window.contextPath}>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-5">
                                        <h1 className="m-0 page-title">Reports </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid" style={{ marginLeft: '10px' }}>
                            <div className="border-bottom"></div>
                            {/* Nav tabs */}
                            <div className="tab-class" >
                                <ul className="nav nav-tabs border-bottom navCluster">
                                    <Link to="/cloud-akshar/reports" className="nav-item" data-toggle="tab"
                                        style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="akshar-daily-report">Daily Reports</li>
                                    </Link>
                                    <Link to="/cloud-akshar/reports/weekly-reports" className="nav-item" data-toggle="tab"
                                        style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="akshar-weekly-report">Weekly Reports</li>
                                    </Link>
                                    <Link to="/cloud-akshar/reports/monthly-reports" className="nav-item" data-toggle="tab"
                                        style={{ textDecoration: 'none' }}>
                                        <li className="nav-link" id="akshar-monthly-report">Monthly Reports</li>
                                    </Link>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/cloud-akshar/reports/weekly-reports" component={WeeklyAksharUsageReport}></Route>
                        <Route path="/cloud-akshar/reports/monthly-reports" component={MonthlyAksharUsageReport}></Route>
                        <Route path="/cloud-akshar/reports" component={DailyAksharUsageReport}></Route>
                    </Switch>
                </div>
            </Router>

        );
    }
}
export default AksharReportTab;



// WEBPACK FOOTER //
// ./src/aksharUi/reports/AksharReportTab.js